var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobFeedbackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.2,10h145.2c10,0,18.2,8.1,18.2,18.2v63.5h9.1V28.2c0-15-12.2-27.2-27.2-27.2H37.2C22.2,0.9,10,13.1,10,28.2v181.5c0,15,12.2,27.2,27.2,27.2v-9.1c-10,0-18.2-8.1-18.2-18.2V28.2C19.1,18.2,27.2,10,37.2,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M46.3,37.2h127.1v9.1H46.3V37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M46.3,64.5h127.1v9.1H46.3V64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M46.3,91.7h45.4v9.1H46.3V91.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M229.6,118.9h-0.3h-45.8v-5.5c0-12-12.9-21.7-28.6-21.7h-17.3c-15.6,0-27.8,9.5-27.8,21.7v5.5H64.3c-10.1,0-18,7.1-18,16.3v20.7v10.8v9.8c0,1.6,0.9,3.1,2.3,3.8c0.4,0.2,3.1,1.9,6.8,3.7v61.8c0,4.7,2.8,9.2,7.8,9.2h164.7c5.1,0,9-5.2,9-9.7v-61.8c3.7-1.8,6.4-3,6.8-3.2c1.4-0.8,2.3-2.2,2.3-3.8v-9.8v-10.8v-20.7C246,125.8,239.3,118.9,229.6,118.9z M227.8,195.9c0,0-8.5,4.8-27.2,8.7v23.2h-18.2v-20.3c-10.2,1.2-22.3,2.1-36.3,2.1c-14,0-26.1-0.8-36.3-2v20.2H91.7v-23.1c-18.7-3.8-27.2-8.5-27.2-8.5v-8.8c6.6,2.8,15.7,5.7,27.2,8.1v-4h18.2v7c10.2,1.3,22.8,2.1,36.3,2.1c13.5,0,25.6-0.8,36.3-2.1v-7h18.2v4c11.3-2.4,20.7-5.3,27.2-8.1V195.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobFeedbackIcon);
export default __webpack_public_path__ + "static/media/job-feedback-icon.bfd43a20c4ca4ddb02ae1ef640633f3b.svg";
export { ForwardRef as ReactComponent };